/* eslint-disable*/
import React, { useState, useEffect } from 'react';
import zoomPlugin from 'chartjs-plugin-zoom';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import {
  Grid,
  Typography,
  TextField,
  Button,
  Checkbox,
  CircularProgress,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Breadcrumbs,
  Link,
  RadioGroup,
  Radio,
  FormControlLabel,
  FormHelperText,
  Slide,
} from '@material-ui/core';
import MaterialTable from 'material-table';
import AddRoundedIcon from '@material-ui/icons/AddRounded';
import { FastField, Formik, Form, Field } from 'formik';
import { object, string, ref, mixed, date, number } from 'yup';
import clsx from 'clsx';
import Autocomplete from '@material-ui/lab/Autocomplete';
import moment from 'moment';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { showErrIfTouched, filterDate } from '../../../../utils';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import { useNavigate } from 'react-router-dom';
/*Detail page*/
import FilterListIcon from '@material-ui/icons/FilterList';
import VisibilityOutlinedIcon from '@material-ui/icons/VisibilityOutlined';
import PeopleAltOutlinedIcon from '@material-ui/icons/PeopleAltOutlined';
import ComputerOutlinedIcon from '@material-ui/icons/ComputerOutlined';
import FavoriteBorderOutlinedIcon from '@material-ui/icons/FavoriteBorderOutlined';
import StarRateIcon from '@material-ui/icons/StarRate';
import ArrowForwardOutlinedIcon from '@material-ui/icons/ArrowForwardOutlined';
import ArrowBackOutlinedIcon from '@material-ui/icons/ArrowBackOutlined';
import ArrowUpwardOutlinedIcon from '@material-ui/icons/ArrowUpwardOutlined';
import ArrowDownwardOutlinedIcon from '@material-ui/icons/ArrowDownwardOutlined';
import RemoveOutlinedIcon from '@material-ui/icons/RemoveOutlined';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar, Line } from 'react-chartjs-2';
import { faker } from '@faker-js/faker';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
/*Detail page*/
import useStyles from '../../Main.style';
import { useParams } from 'react-router-dom';
import useDashboard from '../../../../hooks/useDashboard';
import usePractice from '../../../../hooks/usePractice';
import usePermissions from '../../../../hooks/usePermissions';
import { getLoggedInUserData, addLoader, toProperCase } from '../../../../utils/Helper';
import Moment from 'react-moment';
import NumberFormat from 'react-number-format';
ChartJS.register(
  CategoryScale,
  LinearScale, // Register LinearScale
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
  zoomPlugin, // Register zoom plugin
);

export const optionsForTotalProfit = {
  responsive: true,
  plugins: {
    legend: {
      position: 'bottom', //as const,
      display: false,
    },
    scales: {
      y: {
        title: {
          display: true,
          text: 'Average Response Score (out of 7) ',
        },
        ticks: {
          beginAtZero: true,
          min: 0,
          max: 7,
        },
      },
      x: {
        title: {
          display: true,
          text: 'Cells (Ranked by Average Score)',
        },
      },
    },
    title: {
      display: true,
      text: '',
    },
  },
};

/* Modal */
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';
const VectoHealthReportModel = () => {
  /* Modal */
  const loggedInUserData = getLoggedInUserData();
  const navigate = useNavigate();
  const { userId } = useParams();
  const { countryId } = useParams();
  const [open, setOpen] = React.useState(false);
  const [addNoteDialogOpen, setAddNoteDialogOpen] = React.useState(false);
  const [editDetailsDialogOpen, setEditDetailsDialogOpen] = React.useState(false);
  const [addPermissionDialog, setAddPermissionDialog] = React.useState(false);
  const [editEmployeePermission, setEditEmployeePermission] = useState('');
  const [deleteEmployeePermission, setDeleteEmployeePermission] = useState('');
  const [loggedInUserDetails, setLoggedInUserDetails] = useState([]);
  const [employeeOptions, setEmployeeOptions] = React.useState([]);
  const [visionCultureQuestionsList, setVisionCultureQuestionsList] = useState([]);
  const [peopleQuestionsList, setPeopleQuestionsList] = useState([]);
  const [processAndTechnologyQuestionsList, setProcessAndTechnologyQuestionsList] = useState([]);
  const [communicationAndGivingQuestionsList, setCommunicationAndGivingQuestionsList] = useState(
    [],
  );
  const [healthReportLoader, setHealthReportLoader] = useState(false);
  const [labelsTotalProfit, setLabelsTotalProfit] = useState([]);
  const [myCellListAverage, setMyCellListAverage] = useState([]);
  const [visionAndCultureAvg, setVisionAndCultureAvg] = React.useState();
  const [peopleAvg, setPeopleAvg] = React.useState();
  const [processAndTechnologyAvg, setProcessAndTechnologyAvg] = React.useState();
  const [communicationAndGivingAVG, setCommunicationAndGivingAvg] = React.useState();
  const [totalAVG, setTotalAVG] = React.useState();
  const [visionAndCulture, setVisionAndCulture] = React.useState(true);
  const [showDropDown, setShowDropDown] = React.useState(0);
  const [showState, setShowState] = React.useState(0);

  const [people, setPeople] = React.useState(false);
  const [processAndTech, setProcessAndTech] = React.useState(false);
  const [communicationsAndGiving, setommunicationsAndGiving] = React.useState(false);
  const [openFilter, setOpenFilter] = React.useState(false);
  const [cellListForFilter, setCellListForFilter] = useState([]);
  const [cellIdForReport, setCellIdForReport] = React.useState(loggedInUserData?.cellId);
  const [countryIdForReport, setCountryIdForReport] = React.useState(loggedInUserData?.countryId);
  const [countryName, setCountryName] = React.useState(loggedInUserData?.country?.countryTitle);
  const [cellName, setCellName] = React.useState(loggedInUserData?.cell?.cellTitle);

  const [vectorIdForReport, setVectorIdForReport] = React.useState(100);
  const [dataValuesForCellResponse, setDataValuesForCellResponse] = useState([]);
  const [cellDetails, setCellDetails] = useState([]);
  const [selectedBox, setSelectedBox] = React.useState('visionAndCulture');
  const [selectedBoxValue, setSelectedBoxValue] = React.useState('Vision & Culture');

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });
  const showReports = async (values) => {
    setOpenFilter(false);
    setCountryName(values.countryValue);
    setCellName(values.cellValue);
    setTimeout(() => {
      loadVectorGlobalHealthReport(values?.cellid, values?.countryid, values?.vectorId);
    }, 1500);
  };

  const dataForCellResponse = {
    labels: [
      cellDetails?.id == loggedInUserData?.cellId
        ? 'Cell ' + cellDetails?.cellTitle + ' (Without Leader) ' + 'Your Cell'
        : 'Cell ' + cellDetails?.cellTitle + ' (Without Leader) ',
      'Cell ' + cellDetails?.cellTitle + ' Leader',
    ],
    datasets: [
      {
        data: dataValuesForCellResponse,
        backgroundColor: 'rgb(229 235 240)',
        hoverBackgroundColor: '#003C6F',
      },
    ],
  };
  const dataTotalProfit = {
    labels: labelsTotalProfit,
    datasets: [
      {
        data: myCellListAverage,
        backgroundColor: 'rgb(229 235 240)',
        hoverBackgroundColor: '#003C6F',
      },
    ],
  };

  const loadCountries = async () => {
    const countryLists = await getCountry();
    setCountryList(countryLists.usersResult);
    setVectorList(countryLists.vectorFilter);
  };

  const loadAllCells = async () => {
    const allCellList = await fetchAllCellList();
    setCellListForFilter(allCellList?.usersResult);
    //setCellList(allCellList.usersResult);
  };
  const handleCloseFilter = () => {
    setOpenFilter(false);
  };

  const loadCells = async (countryId) => {
    const allCellList = await getCellData(countryId);
    //setCellList(allCellList.usersResult)ss;
    setCellListForFilter(allCellList?.usersResult);
  };
  const showResult = async (check, value) => {
    setSelectedBox(check);
    setSelectedBoxValue(value);
    //alert(check);
    if (check == 'all') {
      setVisionAndCulture(true);
      setPeople(true);
      setProcessAndTech(true);
      setommunicationsAndGiving(true);
    } else if (check == 'visionAndCulture') {
      setVisionAndCulture(true);
      setPeople(false);
      setProcessAndTech(false);
      setommunicationsAndGiving(false);
    } else if (check == 'people') {
      setVisionAndCulture(false);
      setPeople(true);
      setProcessAndTech(false);
      setommunicationsAndGiving(false);
    } else if (check == 'processAndTech') {
      setVisionAndCulture(false);
      setPeople(false);
      setProcessAndTech(true);
      setommunicationsAndGiving(false);
    } else {
      setVisionAndCulture(false);
      setPeople(false);
      setProcessAndTech(false);
      setommunicationsAndGiving(true);
    }
  };
  const handleClickOpenFilter = () => {
    setOpenFilter(true);
  };

  const loadVectorGlobalHealthReport = async (
    cellIdForReport,
    countryIdForReport,
    vectorIdForReport,
  ) => {
    setHealthReportLoader(true);
    const totalFiles = await getVectorGlobalHealthReport(
      cellIdForReport,
      countryIdForReport,
      vectorIdForReport,
      loggedInUserData?.cellId,
    );
    setVisionAndCultureAvg(totalFiles.visionAndCultureAVG);
    setVisionCultureQuestionsList(totalFiles.visionCultureQuestionsList);
    setPeopleQuestionsList(totalFiles.peopleQuestionsList);
    setProcessAndTechnologyQuestionsList(totalFiles.processAndTechnologyQuestionsList);
    setCommunicationAndGivingQuestionsList(totalFiles.communicationAndGivingQuestionsList);
    setPeopleAvg(totalFiles.peopleAVG);
    setProcessAndTechnologyAvg(totalFiles.processAndTechnologyAVG);
    setCommunicationAndGivingAvg(totalFiles.communicationAndGivingAVG);
    setTotalAVG(totalFiles.totalAVG);
    setLabelsTotalProfit(totalFiles.myCellListLabel);
    setMyCellListAverage(totalFiles.myCellListAverage);
    setDataValuesForCellResponse(totalFiles.dataValuesForCellResponse);
    setCellDetails(totalFiles.cellDetails);

    // Set loader to false first to render the canvas elements
    setHealthReportLoader(false);

    // Use setTimeout to ensure DOM elements are rendered before creating charts
    setTimeout(() => {
      // Create trend chart
      var myChart2 = ChartJS.getChart('trendChart');
      if (myChart2 != undefined) {
        myChart2.destroy();
      }
      const ctx = document.getElementById('trendChart');
      if (ctx) {
        const myChart = new ChartJS(ctx, {
          data: {
            datasets: [
              // {
              //   type: 'line',
              //   pointRadius: 0,
              //   label: loggedInUserData?.country?.countryTitle + ' AVG ' + totalFiles?.avgCountry,
              //   boxWidth: 0,
              //   data: totalFiles.myCountryListAverage,
              //   borderColor: '#a6cee3',
              //   borderWidth: 1,
              // },
              // {
              //   type: 'line',
              //   pointRadius: 0,
              //   label: 'Vector AVG ' + totalFiles?.avgVector,
              //   boxWidth: 0,
              //   data: totalFiles.myVectorAverage,
              //   borderColor: '#0d14188f',
              //   borderWidth: 1,
              // },
              {
                type: 'bar',
                label: 'Average',
                data: totalFiles.myCellListAverage,
                backgroundColor: '#A6CEE3',
                hoverBackgroundColor: '#003C6F',
              },
            ],
            labels: totalFiles.myCellListLabel,
          },

          options: {
            responsive: true,
            scales: {
              y: {
                title: {
                  display: true,
                  text: 'Average Response Score (out of 7) ',
                },
                grid: {
                  display: false,
                },
                ticks: {
                  beginAtZero: true,
                  min: 0,
                  max: 7,
                },
              },
              x: {
                title: {
                  display: true,
                  text: totalFiles.filterText + ' (Ranked by Average Score)',
                },
                grid: {
                  display: false,
                },
              },
            },
            plugins: {
              legend: {
                labels: {
                  usePointStyle: true,
                  boxWidth: 6,
                },
                position: 'bottom', //as const,
                display: true,
              },
              title: {
                display: false,
                position: 'bottom',
                text: '',
              },
            },
          },
        });
      }

      // Create leader chart
      var leaderChart2 = ChartJS.getChart('leaderChart');
      if (leaderChart2 != undefined) {
        leaderChart2?.destroy();
      }
      const ctxLeader = document.getElementById('leaderChart');
      if (ctxLeader) {
        const leaderChart = new ChartJS(ctxLeader, {
          data: {
            datasets: [
              {
                type: 'bar',
                //label: 'Average',
                data: totalFiles.dataValuesForCellResponse,
                backgroundColor: '#A6CEE3',
                hoverBackgroundColor: '#003C6F',
              },
            ],
            labels: [
              totalFiles?.cellDetails?.id == loggedInUserData?.cellId
                ? 'Cell ' + totalFiles?.cellDetails?.cellTitle + ' (Without Leader) ' + 'Your Cell'
                : 'Cell ' + totalFiles?.cellDetails?.cellTitle + ' (Without Leader) ',
              'Cell ' + totalFiles?.cellDetails?.cellTitle + ' Leader',
            ],
            //totalFiles.myCellListLabel,
          },

          options: {
            responsive: true,
            scales: {
              y: {
                title: {
                  display: true,
                  text: 'Average Response Score (out of 7) ',
                },
                grid: {
                  display: false,
                },
                ticks: {
                  beginAtZero: true,
                  min: 0,
                  max: 7,
                },
              },
              x: {
                title: {
                  display: true,
                  text: 'Cells (Ranked by Average Score)',
                },
                grid: {
                  display: false,
                },
              },
            },
            plugins: {
              legend: {
                labels: {
                  usePointStyle: true,
                  boxWidth: 6,
                },
                position: 'bottom', //as const,
                display: false,
              },
              title: {
                display: false,
                position: 'bottom',
                text: '',
              },
            },
          },
        });
      }
    }, 100); // Small delay to ensure DOM elements are rendered
  };

  //OMKAR
  const [countryList, setCountryList] = useState([]);
  const [vectorList, setVectorList] = useState([]);
  const [departmrntList, setDepartmrntList] = useState([]);
  const [cellList, setCellList] = useState([]);
  const [noteDetails, setNoteDetails] = useState('');
  const [noteId, setNoteId] = useState();
  const [countryTitle, setCountryTitle] = useState('');
  const [cellTitle, setCellTitle] = useState('');
  const [departmentTitle, setDepartmentTitle] = useState('');
  const [performanceNotes, setPerformanceNotes] = useState([]);
  const [userDetails, setUserDetails] = useState([]);
  const [subUsers, setSubUsers] = useState([]);
  const [openNoteDelete, setOpenNoteDelete] = React.useState(false);
  const [openNoteEdit, setOpenNoteEdit] = React.useState(false);
  const [menuData, setMenuData] = React.useState(false);

  //OMKAR

  const classes = useStyles();

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [employeeDetailsMenu, setEmployeeDetailsMenu] = React.useState(null);
  const handleMenuClick = (event) => {
    setEmployeeDetailsMenu(event.currentTarget);
  };
  useEffect(() => {
    loadVectorGlobalHealthReport(cellIdForReport, countryIdForReport, vectorIdForReport);
  }, []);

  useEffect(() => {
    loadCountries();
  }, []);

  useEffect(() => {
    loadAllCells();
  }, []);

  const { getUserDetails, fetchAllCellList } = usePractice();
  const { getVectorGlobalHealthReport, getCountry, getCellData } = useDashboard();
  return (
    <Box width={1} p={2}>
      <Grid container direction="row">
        <Grid item xs={12}>
          <Box m={2} />
        </Grid>
        <Grid item xs={12}>
          <Grid container spacing={4}>
            <Grid item xs={12}>
              <Grid container>
                <Grid item xs={12}>
                  <Grid container direction="row" alignItems="center">
                    <Box
                      width={1}
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                      flexWrap="wrap"
                    >
                      <Grid container spacing={4}>
                        <Grid item xs={12} className={classes.innercontent}>
                          <Grid container style={{ height: '100%' }}>
                            <Grid item xs={12}>
                              <Grid container spacing={2}>
                                <Grid item xs={12}>
                                  <Typography variant="h5">Vector General Health</Typography>
                                </Grid>
                                <Grid
                                  item
                                  xs={12}
                                  sm={6}
                                  md={2}
                                  className={classes.vghealthresultsOuter}
                                >
                                  <Box
                                    className={clsx(
                                      classes.innercontentWhite,
                                      selectedBox == 'visionAndCulture'
                                        ? classes.vghealthresultsSelect
                                        : classes.vghealthresults,
                                    )}
                                    onClick={() => {
                                      showResult('visionAndCulture', 'Vision & Culture');
                                    }}
                                  >
                                    <Box>
                                      <Box display="flex" alignItems="center" mb={2}>
                                        <Box display="flex" mr={1}>
                                          <VisibilityOutlinedIcon />
                                        </Box>
                                        <Box>
                                          <Typography
                                            variant="h5"
                                            onClick={() => {
                                              showResult('visionAndCulture', 'Vision & Culture');
                                            }}
                                            noWrap
                                          >
                                            Vision & Culture
                                          </Typography>
                                        </Box>
                                      </Box>
                                      <Box>
                                        <Typography variant="h2" noWrap>
                                          {visionAndCultureAvg} / 7
                                        </Typography>
                                      </Box>
                                    </Box>
                                  </Box>
                                </Grid>
                                <Grid
                                  item
                                  xs={12}
                                  sm={6}
                                  md={2}
                                  className={classes.vghealthresultsOuter}
                                >
                                  <Box
                                    className={clsx(
                                      classes.innercontentWhite,
                                      selectedBox == 'people'
                                        ? classes.vghealthresultsSelect
                                        : classes.vghealthresults,
                                    )}
                                    onClick={() => {
                                      showResult('people', 'PEOPLE');
                                    }}
                                  >
                                    <Box>
                                      <Box display="flex" alignItems="center" mb={2}>
                                        <Box display="flex" mr={1}>
                                          <PeopleAltOutlinedIcon />
                                        </Box>
                                        <Box>
                                          <Typography
                                            variant="h5"
                                            onClick={() => {
                                              showResult('people', 'PEOPLE');
                                            }}
                                            noWrap
                                          >
                                            People
                                          </Typography>
                                        </Box>
                                      </Box>
                                      <Box>
                                        <Typography variant="h2" noWrap>
                                          {peopleAvg} / 7
                                        </Typography>
                                      </Box>
                                    </Box>
                                  </Box>
                                </Grid>
                                <Grid
                                  item
                                  xs={12}
                                  sm={6}
                                  md={2}
                                  className={classes.vghealthresultsOuter}
                                >
                                  <Box
                                    className={clsx(
                                      classes.innercontentWhite,
                                      selectedBox == 'processAndTech'
                                        ? classes.vghealthresultsSelect
                                        : classes.vghealthresults,
                                    )}
                                    onClick={() => {
                                      showResult('processAndTech', 'PROCESS & TECHNOLOGY');
                                    }}
                                  >
                                    <Box>
                                      <Box display="flex" alignItems="center" mb={2}>
                                        <Box display="flex" mr={1}>
                                          <ComputerOutlinedIcon />
                                        </Box>
                                        <Box>
                                          <Typography
                                            variant="h5"
                                            onClick={() => {
                                              showResult('processAndTech', 'PROCESS & TECHNOLOGY');
                                            }}
                                            noWrap
                                          >
                                            Process & Tech
                                          </Typography>
                                        </Box>
                                      </Box>
                                      <Box>
                                        <Typography variant="h2" noWrap>
                                          {processAndTechnologyAvg} / 7
                                        </Typography>
                                      </Box>
                                    </Box>
                                  </Box>
                                </Grid>
                                <Grid
                                  item
                                  xs={12}
                                  sm={6}
                                  md={3}
                                  className={classes.vghealthresultsOuter}
                                >
                                  <Box
                                    className={clsx(
                                      classes.innercontentWhite,
                                      selectedBox == 'communicationsAndGiving'
                                        ? classes.vghealthresultsSelect
                                        : classes.vghealthresults,
                                    )}
                                    onClick={() => {
                                      showResult(
                                        'communicationsAndGiving',
                                        'COMMUNICATION & GIVING',
                                      );
                                    }}
                                  >
                                    <Box>
                                      <Box display="flex" alignItems="center" mb={2}>
                                        <Box display="flex" mr={1}>
                                          <FavoriteBorderOutlinedIcon />
                                        </Box>
                                        <Box>
                                          <Typography
                                            style={{ lineHeight: '14px' }}
                                            variant="h5"
                                            onClick={() => {
                                              showResult(
                                                'communicationsAndGiving',
                                                'COMMUNICATION & GIVING',
                                              );
                                            }}
                                          >
                                            Communications & Giving
                                          </Typography>
                                        </Box>
                                      </Box>
                                      <Box>
                                        <Typography variant="h2" noWrap>
                                          {communicationAndGivingAVG} / 7
                                        </Typography>
                                      </Box>
                                    </Box>
                                  </Box>
                                </Grid>
                                <Grid
                                  item
                                  xs={12}
                                  sm={6}
                                  md={2}
                                  className={classes.vghealthresultsOuter}
                                >
                                  <Box
                                    className={clsx(
                                      classes.innercontentWhite,
                                      selectedBox == 'all'
                                        ? classes.vghealthresultsSelect
                                        : classes.vghealthresults,
                                    )}
                                    onClick={() => {
                                      showResult('all', 'ALL');
                                    }}
                                  >
                                    <Box>
                                      <Box display="flex" alignItems="center" mb={2}>
                                        <Box display="flex" mr={1}>
                                          <StarRateIcon />
                                        </Box>
                                        <Box>
                                          <Typography
                                            variant="h5"
                                            onClick={() => {
                                              showResult('all', 'ALL');
                                            }}
                                            noWrap
                                          >
                                            Total Score
                                          </Typography>
                                        </Box>
                                      </Box>
                                      <Box>
                                        <Typography variant="h2" noWrap>
                                          {totalAVG} / 7
                                        </Typography>
                                      </Box>
                                    </Box>
                                  </Box>
                                </Grid>
                                <Grid
                                  item
                                  xs={12}
                                  sm={12}
                                  md={12}
                                  className={classes.surveyResultsDetail}
                                >
                                  <Box className={classes.innercontentWhite}>
                                    <Box
                                    // display="flex"
                                    // justifyContent="space-between"
                                    // flexDirection={{ xs: 'column', sm: 'column', md: 'row' }}
                                    >
                                      <Box>
                                        <Typography variant="h5" noWrap>
                                          Segment Average Score
                                        </Typography>
                                        <Box
                                          display="flex"
                                          justifyContent="space-between"
                                          alignItems={{
                                            xs: 'flexStart',
                                            sm: 'flexStart',
                                            md: 'center',
                                          }}
                                          flexDirection={{ xs: 'column', sm: 'column', md: 'row' }}
                                        >
                                          <Box py={1}>
                                            <Grid
                                              item
                                              xs={12}
                                              sm={12}
                                              md={12}
                                              className={showState == 1 ? classes.hideChart : ''}
                                            >
                                              <Breadcrumbs
                                                separator={<NavigateNextIcon fontSize="small" />}
                                                aria-label="breadcrumb"
                                              >
                                                <Typography color="textPrimary">
                                                  Vector General Health
                                                </Typography>
                                                <Typography color="textPrimary">
                                                  Segment: ‘{selectedBoxValue}’ Average Score
                                                </Typography>
                                                <Typography color="textPrimary">
                                                  Compare all cells
                                                </Typography>
                                                <Typography color="textPrimary">
                                                  within {toProperCase(countryName)}
                                                </Typography>
                                                <Typography color="textPrimary">
                                                  Segment Details
                                                </Typography>
                                              </Breadcrumbs>
                                            </Grid>
                                          </Box>

                                          <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={12}
                                            className={showState == 0 ? classes.hideChart : ''}
                                          >
                                            <Breadcrumbs
                                              separator={<NavigateNextIcon fontSize="small" />}
                                              aria-label="breadcrumb"
                                            >
                                              <Typography color="textPrimary">
                                                Vector General Health
                                              </Typography>
                                              <Typography color="textPrimary">
                                                Segment: ‘{selectedBoxValue}’ Average Score
                                              </Typography>
                                              <Typography color="textPrimary">
                                                Cell {cellName} Analytics
                                              </Typography>

                                              <Typography color="textPrimary">
                                                Team Members & Team Leader
                                              </Typography>
                                            </Breadcrumbs>
                                          </Grid>
                                          <Box mt={{ xs: 1, sm: 1, md: 0 }}>
                                            <Link
                                              color="textPrimary"
                                              href="/#/app/view-vector-health-report"
                                            >
                                              <Button
                                                endIcon={<ArrowForwardOutlinedIcon />}
                                                color="primary"
                                                variant="contained"
                                                className={classes.VSRDBtn}
                                              >
                                                View Survey Response Details
                                              </Button>
                                            </Link>
                                          </Box>
                                        </Box>
                                      </Box>

                                      <Formik
                                        initialValues={{
                                          countryid: '',
                                          countryValue: '',
                                          cellValue: '',
                                          cellid: '',
                                          vectorId: '',
                                          analyseCell: [],
                                        }}
                                      >
                                        {({
                                          errors,
                                          isSubmitting,
                                          isValid,
                                          dirty,
                                          touched,
                                          setFieldTouched,
                                          setFieldValue,
                                          setFieldError,
                                          setSubmitting,
                                          isSubmitted,
                                          submitForm,
                                          values,
                                          resetForm,
                                        }) => {
                                          return (
                                            <Grid
                                              container
                                              direction="column"
                                              justify="flex-start"
                                              alignItems="center"
                                              className={classes.container}
                                            >
                                              <Grid container direction="row">
                                                <Grid item xs={12}>
                                                  <Grid
                                                    /* spacing={4} */ spacing={4}
                                                    container
                                                    direction="row"
                                                    justify="center"
                                                    alignItems="center"
                                                  >
                                                    <Grid
                                                      item
                                                      align={'right'}
                                                      /* align="right" */ component={Box}
                                                      xs={12}
                                                      sm={4}
                                                      md={4}
                                                    ></Grid>
                                                  </Grid>
                                                </Grid>
                                              </Grid>

                                              <Grid container>
                                                <Grid item xs={12} className={classes.TabBlock}>
                                                  <Grid container spacing={4}>
                                                    <Grid item xs={12}>
                                                      {/* <Box m={1} /> */}
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                      <Grid container direction="row">
                                                        <Grid
                                                          item
                                                          xs={12}
                                                          className={classes.FilterButtonMobile}
                                                        >
                                                          <Box>
                                                            <Button
                                                              startIcon={<FilterListIcon />}
                                                              color="primary"
                                                              onClick={handleClickOpenFilter}
                                                            >
                                                              Filters
                                                            </Button>
                                                            <If condition={openFilter}>
                                                              <Dialog
                                                                fullScreen
                                                                open={openFilter}
                                                                onClose={handleCloseFilter}
                                                                TransitionComponent={Transition}
                                                              >
                                                                <DialogTitle id="simple-dialog-title">
                                                                  <Box
                                                                    display="flex"
                                                                    justifyContent="space-between"
                                                                  >
                                                                    <Box
                                                                      style={{ cursor: 'pointer' }}
                                                                      onClick={() => {
                                                                        resetForm();
                                                                        setShowState(0);
                                                                        setCountryName(
                                                                          loggedInUserData?.country
                                                                            ?.countryTitle,
                                                                        );
                                                                        setCellName(
                                                                          loggedInUserData?.cell
                                                                            ?.cellTitle,
                                                                        );
                                                                        loadVectorGlobalHealthReport(
                                                                          loggedInUserData?.cellId,
                                                                          loggedInUserData?.countryId,
                                                                          vectorIdForReport,
                                                                        );
                                                                      }}
                                                                    >
                                                                      Clear All
                                                                    </Box>
                                                                    <Box>
                                                                      <b>Filters</b>
                                                                    </Box>
                                                                    <Box
                                                                      style={{ cursor: 'pointer' }}
                                                                      onClick={handleCloseFilter}
                                                                    >
                                                                      Cancel
                                                                    </Box>
                                                                  </Box>
                                                                </DialogTitle>
                                                                <DialogContent>
                                                                  <Grid container spacing={2}>
                                                                    <Grid item xs={12}>
                                                                      <Autocomplete
                                                                        id="countryid"
                                                                        options={countryList}
                                                                        getOptionLabel={(option) =>
                                                                          option?.countryTitle
                                                                        }
                                                                        getOptionSelected={(
                                                                          option,
                                                                          value,
                                                                        ) =>
                                                                          option?.id === value?.id
                                                                        }
                                                                        value={
                                                                          values?.countryid
                                                                            ? countryList.find(
                                                                                (d) =>
                                                                                  d?.id ===
                                                                                  values?.countryid,
                                                                              )
                                                                            : null
                                                                        }
                                                                        onChange={(e, value) => {
                                                                          if (
                                                                            value?.id != 1 ||
                                                                            value?.id != '1'
                                                                          ) {
                                                                            loadCells(
                                                                              value?.id || '',
                                                                            );
                                                                          }
                                                                          setFieldValue(
                                                                            'countryValue',
                                                                            value?.countryTitle ||
                                                                              '',
                                                                          );

                                                                          setFieldValue(
                                                                            'countryid',
                                                                            value?.id || '',
                                                                          );
                                                                          setFieldValue(
                                                                            'cellid',
                                                                            '',
                                                                          );
                                                                          setFieldValue(
                                                                            'vectorId',
                                                                            '',
                                                                          );

                                                                          setTimeout(() => {
                                                                            setFieldTouched(
                                                                              'countryid',
                                                                            );
                                                                            setFieldTouched(
                                                                              'cellid',
                                                                            );
                                                                          }, 1000);
                                                                        }}
                                                                        disabled={isSubmitted}
                                                                        renderInput={(params) => (
                                                                          <TextField
                                                                            {...params}
                                                                            label="Compare within"
                                                                            name="countryid"
                                                                            variant="outlined"
                                                                          />
                                                                        )}
                                                                        popupIcon={
                                                                          <ExpandMoreIcon />
                                                                        }
                                                                      />
                                                                    </Grid>

                                                                    <If
                                                                      condition={showDropDown == 1}
                                                                    >
                                                                      <Grid item xs={12}>
                                                                        <Autocomplete
                                                                          id="vectorId"
                                                                          options={vectorList}
                                                                          getOptionLabel={(
                                                                            option,
                                                                          ) => option?.countryTitle}
                                                                          getOptionSelected={(
                                                                            option,
                                                                            value,
                                                                          ) =>
                                                                            option?.id === value?.id
                                                                          }
                                                                          value={
                                                                            values?.vectorId
                                                                              ? vectorList.find(
                                                                                  (d) =>
                                                                                    d?.id ===
                                                                                    values?.vectorId,
                                                                                )
                                                                              : null
                                                                          }
                                                                          onChange={(e, value) => {
                                                                            setFieldValue(
                                                                              'vectorId',
                                                                              value?.id || '',
                                                                            );
                                                                            setTimeout(() => {
                                                                              setFieldTouched(
                                                                                'vectorId',
                                                                              );
                                                                            }, 1000);
                                                                          }}
                                                                          disabled={isSubmitted}
                                                                          renderInput={(params) => (
                                                                            <TextField
                                                                              {...params}
                                                                              label="Group by"
                                                                              name="vectorId"
                                                                              variant="outlined"
                                                                            />
                                                                          )}
                                                                          popupIcon={
                                                                            <ExpandMoreIcon />
                                                                          }
                                                                        />
                                                                      </Grid>
                                                                    </If>
                                                                    <If
                                                                      condition={showDropDown == 0}
                                                                    >
                                                                      <Grid item xs={12}>
                                                                        <Autocomplete
                                                                          disabled={
                                                                            values.countryid == ''
                                                                          }
                                                                          options={
                                                                            cellListForFilter
                                                                          }
                                                                          getOptionLabel={(
                                                                            option,
                                                                          ) => option?.cellTitle}
                                                                          getOptionSelected={(
                                                                            option,
                                                                            value,
                                                                          ) =>
                                                                            option?.id === value?.id
                                                                          }
                                                                          value={
                                                                            values?.cellid
                                                                              ? cellListForFilter.find(
                                                                                  (d) =>
                                                                                    d?.id ===
                                                                                    values?.cellid,
                                                                                )
                                                                              : null
                                                                          }
                                                                          onChange={(e, value) => {
                                                                            setTimeout(
                                                                              () =>
                                                                                setFieldTouched(
                                                                                  'cellid',
                                                                                ),
                                                                              1000,
                                                                            );
                                                                            setFieldValue(
                                                                              'cellValue',
                                                                              value?.cellTitle ||
                                                                                '',
                                                                            );
                                                                            setFieldValue(
                                                                              'cellid',
                                                                              value?.id || '',
                                                                            );
                                                                          }}
                                                                          renderInput={(params) => (
                                                                            <TextField
                                                                              {...params}
                                                                              name="cellid"
                                                                              variant="outlined"
                                                                              label="Cell"
                                                                            />
                                                                          )}
                                                                          popupIcon={
                                                                            <ExpandMoreIcon />
                                                                          }
                                                                        />
                                                                      </Grid>
                                                                    </If>
                                                                    <If
                                                                      condition={
                                                                        values.cellid != '' &&
                                                                        values.cellid != 1
                                                                      }
                                                                    >
                                                                      <Grid
                                                                        item
                                                                        xs={12}
                                                                        className={
                                                                          classes.RadioStyle
                                                                        }
                                                                      >
                                                                        <Field as={RadioGroup}>
                                                                          <FormControlLabel
                                                                            control={
                                                                              <Field
                                                                                as={Checkbox}
                                                                                value={'1'}
                                                                                name="analyseCell"
                                                                                onChange={(e) => {
                                                                                  if (
                                                                                    showState == 0
                                                                                  ) {
                                                                                    setShowState(1);
                                                                                  } else {
                                                                                    setShowState(0);
                                                                                  }
                                                                                }}
                                                                              />
                                                                            }
                                                                            label={
                                                                              'Analyze a selected cell'
                                                                            }
                                                                          />
                                                                        </Field>
                                                                      </Grid>
                                                                    </If>
                                                                  </Grid>
                                                                </DialogContent>
                                                                <DialogActions>
                                                                  <Button
                                                                    type="New Message"
                                                                    variant="contained"
                                                                    color="primary"
                                                                    onClick={() =>
                                                                      showReports(values)
                                                                    }
                                                                    fullWidth
                                                                  >
                                                                    Apply
                                                                  </Button>
                                                                </DialogActions>
                                                              </Dialog>
                                                            </If>
                                                          </Box>
                                                        </Grid>
                                                        <Grid
                                                          item
                                                          xs={12}
                                                          className={classes.FilterDesktop}
                                                        >
                                                          <Grid container spacing={2}>
                                                            <Grid
                                                              item
                                                              className={
                                                                classes.FilterDropdownWidth
                                                              }
                                                            >
                                                              <Autocomplete
                                                                id="countryid"
                                                                options={countryList}
                                                                getOptionLabel={(option) =>
                                                                  option?.countryTitle
                                                                }
                                                                getOptionSelected={(
                                                                  option,
                                                                  value,
                                                                ) => option?.id === value?.id}
                                                                value={
                                                                  values?.countryid
                                                                    ? countryList.find(
                                                                        (d) =>
                                                                          d?.id ===
                                                                          values?.countryid,
                                                                      )
                                                                    : null
                                                                }
                                                                onChange={(e, value) => {
                                                                  if (
                                                                    value?.id != 1 ||
                                                                    value?.id != '1'
                                                                  ) {
                                                                    setShowDropDown(0);
                                                                    loadCells(value?.id || '');
                                                                  } else {
                                                                    setShowDropDown(1);
                                                                  }
                                                                  setFieldValue(
                                                                    'countryValue',
                                                                    value?.countryTitle || '',
                                                                  );
                                                                  setFieldValue(
                                                                    'countryid',
                                                                    value?.id || '',
                                                                  );
                                                                  setFieldValue('vectorId', '');
                                                                  setFieldValue('cellid', '');

                                                                  setTimeout(() => {
                                                                    setFieldTouched('countryid');
                                                                    setFieldTouched('cellid');
                                                                  }, 1000);
                                                                }}
                                                                disabled={isSubmitted}
                                                                renderInput={(params) => (
                                                                  <TextField
                                                                    {...params}
                                                                    label="Compare within"
                                                                    name="countryid"
                                                                    variant="outlined"
                                                                  />
                                                                )}
                                                                popupIcon={<ExpandMoreIcon />}
                                                              />
                                                            </Grid>
                                                            <If condition={showDropDown == 1}>
                                                              <Grid
                                                                item
                                                                className={
                                                                  classes.FilterDropdownWidth
                                                                }
                                                              >
                                                                <Autocomplete
                                                                  id="vectorId"
                                                                  options={vectorList}
                                                                  getOptionLabel={(option) =>
                                                                    option?.countryTitle
                                                                  }
                                                                  getOptionSelected={(
                                                                    option,
                                                                    value,
                                                                  ) => option?.id === value?.id}
                                                                  value={
                                                                    values?.vectorId
                                                                      ? vectorList.find(
                                                                          (d) =>
                                                                            d?.id ===
                                                                            values?.vectorId,
                                                                        )
                                                                      : null
                                                                  }
                                                                  onChange={(e, value) => {
                                                                    setFieldValue(
                                                                      'vectorId',
                                                                      value?.id || '',
                                                                    );
                                                                    setTimeout(() => {
                                                                      setFieldTouched('vectorId');
                                                                    }, 1000);
                                                                  }}
                                                                  disabled={isSubmitted}
                                                                  renderInput={(params) => (
                                                                    <TextField
                                                                      {...params}
                                                                      label="Group by"
                                                                      name="vectorId"
                                                                      variant="outlined"
                                                                    />
                                                                  )}
                                                                  popupIcon={<ExpandMoreIcon />}
                                                                />
                                                              </Grid>
                                                            </If>
                                                            <If condition={showDropDown == 0}>
                                                              <Grid
                                                                item
                                                                className={
                                                                  classes.FilterDropdownWidth
                                                                }
                                                              >
                                                                <Autocomplete
                                                                  disabled={values.countryid == ''}
                                                                  options={cellListForFilter}
                                                                  getOptionLabel={(option) =>
                                                                    option?.cellTitle
                                                                  }
                                                                  getOptionSelected={(
                                                                    option,
                                                                    value,
                                                                  ) => option?.id === value?.id}
                                                                  value={
                                                                    values?.cellid
                                                                      ? cellListForFilter.find(
                                                                          (d) =>
                                                                            d?.id ===
                                                                            values?.cellid,
                                                                        )
                                                                      : null
                                                                  }
                                                                  onChange={(e, value) => {
                                                                    setTimeout(
                                                                      () =>
                                                                        setFieldTouched('cellid'),
                                                                      1000,
                                                                    );
                                                                    setFieldValue(
                                                                      'cellValue',
                                                                      value?.cellTitle || '',
                                                                    );
                                                                    setFieldValue(
                                                                      'cellid',
                                                                      value?.id || '',
                                                                    );

                                                                    // Deselect "Analyze a selected cell" checkbox when "All Cells" is selected (id == 1)
                                                                    if (value?.id == 1) {
                                                                      setFieldValue(
                                                                        'analyseCell',
                                                                        [],
                                                                      );
                                                                      setShowState(0);
                                                                    }
                                                                  }}
                                                                  renderInput={(params) => (
                                                                    <TextField
                                                                      {...params}
                                                                      name="cellid"
                                                                      variant="outlined"
                                                                      label="Cell"
                                                                    />
                                                                  )}
                                                                  popupIcon={<ExpandMoreIcon />}
                                                                />
                                                              </Grid>
                                                            </If>
                                                            <Grid item>
                                                              <Button
                                                                type="New Message"
                                                                className={classes.button}
                                                                variant="outlined"
                                                                onClick={() => showReports(values)}
                                                              >
                                                                Apply
                                                              </Button>
                                                            </Grid>
                                                            <Grid item>
                                                              <Button
                                                                disabled={values.countryid == ''}
                                                                variant="text"
                                                                className={classes.clearbtn}
                                                                onClick={() => {
                                                                  resetForm();
                                                                  setShowState(0);
                                                                  setCountryName(
                                                                    loggedInUserData?.country
                                                                      ?.countryTitle,
                                                                  );
                                                                  setCellName(
                                                                    loggedInUserData?.cell
                                                                      ?.cellTitle,
                                                                  );
                                                                  loadVectorGlobalHealthReport(
                                                                    loggedInUserData?.cellId,
                                                                    loggedInUserData?.countryId,
                                                                    vectorIdForReport,
                                                                  );
                                                                }}
                                                              >
                                                                Clear
                                                              </Button>
                                                            </Grid>
                                                            <If
                                                              condition={
                                                                values.cellid != '' &&
                                                                values.cellid != 1
                                                              }
                                                            >
                                                              <Grid
                                                                item
                                                                xs={12}
                                                                className={classes.RadioStyle}
                                                              >
                                                                <Field as={RadioGroup}>
                                                                  <FormControlLabel
                                                                    control={
                                                                      <Field
                                                                        as={Checkbox}
                                                                        value={'1'}
                                                                        color="tertiary"
                                                                        name="analyseCell"
                                                                        checked={
                                                                          values?.analyseCell?.indexOf(
                                                                            '1',
                                                                          ) > -1
                                                                        }
                                                                        onClick={(e) => {
                                                                          values?.analyseCell
                                                                            .length == 0
                                                                            ? setShowState(1)
                                                                            : setShowState(0);
                                                                        }}
                                                                      />
                                                                    }
                                                                    label={
                                                                      'Analyze a selected cell'
                                                                    }
                                                                  />
                                                                </Field>
                                                              </Grid>
                                                            </If>
                                                          </Grid>
                                                        </Grid>
                                                      </Grid>

                                                      <Box mt={2} />
                                                    </Grid>
                                                  </Grid>
                                                </Grid>
                                              </Grid>
                                            </Grid>
                                          );
                                        }}
                                      </Formik>
                                    </Box>

                                    <Grid item xs={12}>
                                      <Grid container style={{ height: '100%' }}>
                                        <Grid item xs={12}>
                                          <Grid container spacing={2}>
                                            <Grid
                                              item
                                              xs={12}
                                              sm={12}
                                              md={12}
                                              className={showState == 1 ? classes.hideChart : ''}
                                            >
                                              {healthReportLoader ? (
                                                addLoader(200)
                                              ) : (
                                                <Box>
                                                  <canvas
                                                    id="trendChart"
                                                    width="300"
                                                    height="150"
                                                  ></canvas>
                                                </Box>
                                              )}
                                            </Grid>

                                            <Grid
                                              item
                                              xs={12}
                                              sm={12}
                                              md={12}
                                              className={showState == 0 ? classes.hideChart : ''}
                                            >
                                              {healthReportLoader ? (
                                                addLoader(200)
                                              ) : (
                                                <Box>
                                                  <canvas
                                                    id="leaderChart"
                                                    width="300"
                                                    height="150"
                                                  ></canvas>
                                                </Box>
                                              )}
                                            </Grid>
                                          </Grid>
                                        </Grid>
                                      </Grid>
                                    </Grid>
                                  </Box>
                                </Grid>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Box>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12}>
          <Box m={2} />
        </Grid>
        <Grid item xs={12}>
          <Grid container spacing={4}>
            <div className={classes.ExpandBlock}></div>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default VectoHealthReportModel;
